import html2canvas from "html2canvas";
import { getGenerator } from "./getGenerator";

export const getImageUrl = async (className) => {
    const captureElements = Array.from(
        document.getElementsByClassName(className)
    );

    let dataImage = []

    for await (let i of getGenerator(captureElements.length)) {
        const captureElement = captureElements[i];

        await (html2canvas(captureElement, { scale: 2 }).then((canvas) => {
            const contentDataURL = canvas.toDataURL('image/png');
             
            dataImage.push({ url: contentDataURL, height: (canvas?.height * 208 / canvas?.width) })
        }));
    }

    return dataImage
}